export const MaintenanceCompanyEnum = {
  id: 20724,
};
